module.exports = __webpack_public_path__ + "img/prompt.588c45fd.png";